import {Component} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

// Configuracion de infraestructura (puertos) que el Initializer baja a las BD de
// MoneyManager y LockManager, y que esos binarios (y Theo) usan. Es una unica
// configuracion por cajero (no una lista de dispositivos).
class TabManager extends Component {
    constructor(props) {
        super(props)

        var dispositivos = props.dispositivos
        this.guardarEvent = props.event

        // Toma la config existente (primer elemento) o defaults.
        var actual = (Array.isArray(dispositivos) && dispositivos.length > 0) ? dispositivos[0] : {}

        // Campos vacios por defecto; el valor sugerido va como placeholder. Si se
        // dejan vacios, MoneyManager/LockManager mostraran error (no se hardcodea).
        this.state = {
            tipoDispositivo: props.tipoDispositivo,
            cmbDepositario: actual.depositario || "",
            txtPuertoEsp: actual.puerto_esp || ""
        }

        // Depositarios soportados. El valor guardado lo usa el Initializer
        // (CDbGraficos) para fijar las imagenes de la tabla Controles (id 237/238).
        this.depositarios = ["Sinqa 10", "Sinqa 100", "Sinqa 20", "Sinqa 200", "Sinqa 500"]
    }

    onChangeDepositario = (event) => {
        this.setState({cmbDepositario: event.target.value})
    }

    onChangePuertoEsp = (event) => {
        this.setState({txtPuertoEsp: event.target.value.toString()})
    }

    // Todos los campos son OBLIGATORIOS para poder guardar. Un combo sin elegir vale
    // 0 (numero) y un texto vacio vale "" -> ambos se rechazan.
    camposValidos = () => {
        const campos = [
            this.state.cmbDepositario,
            this.state.txtPuertoEsp
        ]
        const vacio = campos.some(v => v === undefined || v === null || v === 0 || (typeof v === 'string' && v.trim() === ""))
        if (vacio) {
            window.alert("Todos los campos son obligatorios para guardar.")
            return false
        }
        return true
    }

    btnGuardarClick = () => {
        if (!this.camposValidos()) return

        var item = {
            depositario: this.state.cmbDepositario,
            puerto_esp: this.state.txtPuertoEsp
        }

        // Config unica: se guarda como arreglo de un elemento (consistente con el
        // resto, que el Initializer lee con getJSONObject(0)).
        this.guardarEvent(this.state.tipoDispositivo, [item], () => {})
    }

    render() {
        return(
            <Box>
                <Grid container xs={12}>
                    <Grid item xs={12}>
                        <Card fullWidth>
                            <CardContent>
                                <h3>Manager</h3>
                                <form>
                                    <br />
                                    <br />
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth component="fieldset">
                                                <InputLabel id="lblDepositario">Depositario</InputLabel>
                                                <Select
                                                labelId="lblDepositario"
                                                label="Depositario"
                                                value={this.state.cmbDepositario}
                                                onChange={this.onChangeDepositario}>
                                                {this.depositarios.map(dep => (
                                                <MenuItem key={dep} value={dep}>{dep}</MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth component="fieldset">
                                                <TextField
                                                label="Puerto Tarjeta Controladora ESP"
                                                variant="outlined"
                                                value={this.state.txtPuertoEsp}
                                                placeholder="/dev/ttyUSB0"
                                                onChange={this.onChangePuertoEsp}
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </form>
                            </CardContent>
                            <CardActions>
                                <Button variant="contained" onClick={this.btnGuardarClick}>Guardar</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    }
}

export default TabManager
